import english from "i18n-iso-countries/langs/en.json";

/** English ISO country names and aliases, without bundling every locale. */
export const organizationCountries = Object.entries(english.countries)
  .map(([id, names]) => {
    const aliases = typeof names === "string" ? [names] : names;
    return {
      id,
      name: id === "US" ? "United States" : aliases[0]!,
      aliases: [...aliases, ...(id === "US" ? ["USA"] : [])],
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name, "en"));

/** Accept existing free-text answers as well as new ISO alpha-2 selections. */
export function organizationCountryCode(value: string): string | undefined {
  const normalized = value.trim().toLowerCase();
  return organizationCountries.find(
    (country) =>
      country.id.toLowerCase() === normalized ||
      country.name.toLowerCase() === normalized ||
      country.aliases.some((alias) => alias.toLowerCase() === normalized),
  )?.id;
}

export function organizationCountryName(value: string): string {
  const code = organizationCountryCode(value);
  return (
    organizationCountries.find((country) => country.id === code)?.name ?? value
  );
}
